import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);

// styled select with a floating label
class ParallaxDecoration extends HTMLElement {
  constructor() {
    super();
    this.parallaxElements = this.querySelectorAll('.js-parallax__element');
    this.timeline = gsap.timeline();
  }
  connectedCallback() {
    // binding handler
    this.bindedInit = this.init.bind(this);

    // on load
    this.init();

    // listeners
    // this.selectElement.addEventListener('click', this.bindedHandleChangeValue)
  }
  disconnectedCallback() {}
  init() {
    this.parallaxElements.forEach(element => {
      // class to reveal the stuff
      gsap.set(element, {
        opacity: 1
      });

      // gsap animation
      const animation = gsap.to(element, {
        y: '-30%',
        scrollTrigger: {
          trigger: element,
          scrub: true,
          start: 'top bottom',
          // start when element enters viewport
          end: 'bottom top',
          // end when element leaves viewport
          toggleActions: "play none none reset" // play when enters, reset when leaves
        }
      });
      this.timeline.add(animation);
    });
  }
}
customElements.define('parallax-decoration', ParallaxDecoration);